import { useState } from 'react'
import { Create_Section } from '@graphql/mutations'
import { useApi } from '@hooks/useApi'
import { useSections } from '@hooks/useSections'

const useCreateSection = () => {
  const [isPosting, setIsPosting] = useState(false)
  const { postMutation } = useApi()

  const { mutate } = useSections()

  const post = async (data, successMessage, errorMessage) => {
    setIsPosting(true)

    const res = await postMutation(
      data,
      Create_Section,
      successMessage ? successMessage : 'Avsnitt skapat.',
      errorMessage ? errorMessage : 'Nåt gick fel när avsnittet skulle skapas.',
      async () => {
        await mutate() // refetch sections listing
      }
    )

    setIsPosting(false)
    return res
  }

  return {
    post,
    isPosting,
  }
}

export { useCreateSection }
